import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth();
    const location = useLocation();

    // Check if user has an access token
    if (!auth?.accessToken) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If allowedRoles is specified, check if user's role is in the allowed list
    if (allowedRoles && allowedRoles.length > 0) {
        const userRole = auth?.role?.toLowerCase();
        const isAllowed = allowedRoles.some(role => role.toLowerCase() === userRole);

        if (!isAllowed) {
            // User is authenticated but doesn't have the required role
            // Redirect to unauthorized page or home
            return <Navigate to="/unauthorized" state={{ from: location }} replace />;
        }
    }

    return <Outlet />;
}

export default RequireAuth;